import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
var ColorInputWrapper = styled('div')({
    marginLeft: '10px',
    width: '100%',
    backgroundColor: 'transparent',
    border: '1px solid grey',
    borderRadius: '5px',
    boxSizing: 'border-box',
});
var ColorInput = styled('input')({
    width: '100%',
    height: '30px',
    border: 'none',
    backgroundColor: 'transparent',
});
var CustomColorPicker = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = useState(value || '#000000'), color = _b[0], setColor = _b[1]; // Use the prop or fallback to a default color
    useEffect(function () {
        // Update the color if the prop changes
        setColor(value);
    }, [value]);
    var handleColorChange = function (event) {
        var newColor = event.target.value;
        setColor(newColor);
        if (onChange) {
            onChange(newColor); // Call the optional onChange callback if provided
        }
    };
    return (_jsx(_Fragment, { children: _jsx(ColorInputWrapper, { children: _jsx(ColorInput, { type: "color", value: color, onChange: handleColorChange }) }) }));
};
export default CustomColorPicker;
